import { Routes } from "@angular/router";
import { ReportViewerComponent } from "./personas/reports/report-viewer/report-viewer.component";
import { ccmViewGuard, adminViewGuard, reportViewGuard, cmViewGuard } from "./core/authentication/auth.guard";
import { UnauthorizedComponent } from "./shared/components/unauthorized/unauthorized.component";
import { CCM_REDIRECT_ROUTES } from "./personas/ccm/ccm.routes";
import { CM_REDIRECT_ROUTES } from "./personas/cm/cm.routes";
import { HomeownerPhotoViewerComponent } from "./personas/homeowner/components/homeowner-photo-viewer/homeowner-photo-viewer.component";


export const routes: Routes = [
  {
    path: "cm",
    canActivate: [cmViewGuard],
    loadChildren: () => import("./personas/cm/cm.routes").then(m => m.CM_ROUTES)
  },

  {
    path: "ccm",
    canActivate: [ccmViewGuard],
    loadChildren: () => import("./personas/ccm/ccm.routes").then(m => m.CCM_ROUTES)
  },

  {
    path: "admin",
    canActivate: [adminViewGuard],
    loadChildren: () => import("./personas/admin/admin.routes").then(m => m.ADMIN_ROUTES)
  },

  {
    path: "vendors",
    loadChildren: () => import("./personas/vendor/vendor.routes").then(m => m.VENDOR_ROUTES)
  },

  {
    path: "homeowners",
    loadChildren: () => import("./personas/homeowner/homeowner.routes").then(m => m.HOMEOWNER_ROUTES)
  },

  {
    path: "reports/:externalLotId",
    component: ReportViewerComponent,
    canActivate: [reportViewGuard]
  },

  {
    path: "homeowner-photos/:assetIdentifier",
    component: HomeownerPhotoViewerComponent,
    canActivate: [reportViewGuard]
  },

  {
    path: "unauthorized",
    component: UnauthorizedComponent
  },

  ...CCM_REDIRECT_ROUTES,
  ...CM_REDIRECT_ROUTES,

  {
    path: "**",
    redirectTo: "ccm"
  },
];
